import {
  FormControl,
  MenuItem,
  Select,
  SelectChangeEvent,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMoreRounded";

type CustomDropdownProps = {
  value: string;
  onChange: (event: SelectChangeEvent) => void;
  onClick?: () => void;
  options: string[];
  placeholder?: string;
  width?: number | string;
  background?: string;
  boxShadow?: string;
};

const StyledFormControl = styled(FormControl)<{
  width?: number | string;
  background?: string;
  boxShadow?: string;
}>(({ theme, width, background, boxShadow }) => ({
  width: width || 230,
  height: 40,
  boxShadow: boxShadow || "none",
  background: background || theme.palette.background.default,
  "& .MuiOutlinedInput-root": {
    borderRadius: 10,
    fontSize: 16,
    border: "1px solid rgba(223, 221, 221, 1)",
  },
  "& .MuiSvgIcon-root": {
    right: 10,
  },
}));

const CustomDropdown = (props: CustomDropdownProps) => {
  const {
    value,
    onChange,
    onClick,
    options,
    placeholder,
    width,
    background,
    boxShadow,
  } = props;
  return (
    <StyledFormControl
      size="small"
      width={width}
      background={background}
      boxShadow={boxShadow}
      sx={{ textAlign: "left", borderRadius: "10px" }}
    >
      <Select
        displayEmpty
        value={value}
        onChange={onChange}
        onClick={onClick}
        IconComponent={ExpandMoreIcon}
        renderValue={(selected) =>
          selected ? (
            selected
          ) : (
            <Typography color="text.secondary">{placeholder}</Typography>
          )
        }
        MenuProps={{
          PaperProps: {
            sx: {
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
              borderBottomLeftRadius: 10,
              borderBottomRightRadius: 10,
              alignItems: "center",
            },
          },
        }}
      >
        {options.map((option, index) => (
          <MenuItem
            value={option}
            key={option}
            sx={{
              justifyContent: "center",
              textAlign: "center",
              borderBottom:
                index !== options.length - 1 ? "1px solid #DFDDDD" : "none",
              py: 1,
              "&.Mui-selected": {
                backgroundColor: "transparent",
              },
              "&.Mui-selected:hover": {
                backgroundColor: "transparent",
              },
              "&:hover": {
                backgroundColor: "#transparent",
              },
            }}
          >
            {option}
          </MenuItem>
        ))}
      </Select>
    </StyledFormControl>
  );
};

export default CustomDropdown;
